module.exports = __webpack_public_path__ + "img/shift-empty-image.4b524008.webp";